import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActualizaFundersComponent } from './actualizafunders.component';
import { ContribuyentefundersComponent } from './contribuyentefunders.component';
import { CreaCreditlineDolaresComponent } from './creacreditlinedolares.component';
import { CreaCreditlinePesosComponent } from './creacreditlinepesos.component';
import { RouterModule } from '@angular/router';
import { CreaFundersComponent } from './creafunders.component';
import { MantFunMainComponent } from './mantfunmain.component';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule, 
        ReactiveFormsModule


    ],
    declarations: [
        ActualizaFundersComponent,
        ContribuyentefundersComponent,
        CreaCreditlineDolaresComponent,
        CreaCreditlinePesosComponent,
        CreaFundersComponent,
        MantFunMainComponent
    ],
    exports: [
        ActualizaFundersComponent,
        ContribuyentefundersComponent,
        CreaCreditlineDolaresComponent,
        CreaCreditlinePesosComponent,
        CreaFundersComponent,
        MantFunMainComponent
    ]
})
export class ContribuyenteFundersModule { }
